import React, { useState, useEffect } from 'react';
import ChatInterface from './ChatInterface';
import Sidebar from './Sidebar';
import './ChatPage.css';

/**
 * ChatPage component that serves as the container for the chat interface
 * Implements a modern design with responsive sidebar
 */
const ChatPage = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  // Check if mobile view
  useEffect(() => {
    const checkIfMobile = () => {
      const isMobileView = window.innerWidth <= 768;
      setIsMobile(isMobileView);
      if (isMobileView) {
        setIsSidebarOpen(false);
      } else {
        setIsSidebarOpen(true);
      }
    };

    // Check on mount
    checkIfMobile();

    // Add event listener for window resize
    window.addEventListener('resize', checkIfMobile);
    
    // Cleanup
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="chat-page">
      <div className={`sidebar-container ${isSidebarOpen ? 'open' : ''}`}>
        <Sidebar onClose={toggleSidebar} />
      </div>
      {isMobile && isSidebarOpen && (
        <button
          type="button"
          className="sidebar-overlay"
          onClick={toggleSidebar}
          aria-label="Close navigation"
        ></button>
      )}
      <div className="chat-container">
        <ChatInterface onMenuClick={toggleSidebar} isMobile={isMobile} />
      </div>
    </div>
  );
};

export default ChatPage;
